import { CoreFetch, CodingRulesApi, ProviderCodingRule } from '@enter/core';
import { makeObservable, observable, runInAction } from 'mobx';

export class CodingRulesStore {
    @observable public loading: boolean = false;
    @observable public rules: ProviderCodingRule[] = [];

    constructor() {
        makeObservable(this);
    }

    public fetch = async (): Promise<void> => {
        runInAction(() => {
            this.loading = true;
        });

        try {
            const rules = await CoreFetch<CodingRulesApi>(CodingRulesApi).listProviderCodingRules({});
            
            runInAction(() => {
                this.rules = rules;
                this.loading = false;
            });
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            });
            throw error;
        }
    };
}

export default new CodingRulesStore();
